import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const ModalBody = ({ children }: Props) => {
  return <div className='p-4'>{children}</div>;
};
